// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","pageContainer":"App_pageContainer__H23-Q","background":"App_background__IxVd3"};